<template>
  <div class="top-bar-container" :class="{'z-index-for-tour-unset': isTourFixAppliedToTable}" data-v-tour="topBarStatus">
    <div class="view-header d-flex justify-content-between align-items-center ">
      <template v-if="referral">
        <div class="text-left ">
          <status :referralId="referralId" style="font-size: 1.4875rem" :showIndicator="false" />
        </div>
        <div class=" text-right">
          <div class="d-flex align-content-center justify-content-end ml-auto text-right">
            <template v-if="!referral.sent_time">
              <font-awesome-icon v-if="referral.is_saving" icon="spinner-third" spin class="mr-3 text-primary align-self-center" />
              <span v-else class="text-muted text-nowrap mr-3 justify-content-center align-self-center">Last saved
                <from-now :time="referral.updated_at" />
              </span>
            </template>
            <!-- <span v-else class="text-muted text-nowrap mr-3 justify-content-center align-self-center">{{ referral.is_incoming ? 'Received' : 'Sent'}} {{moment(referral.sent_time).fromNow()}}</span> -->

            <!-- <button v-if="isSchedulable && user.practice.sms_number" class="btn btn-lg btn-primary btn-block d-flex align-items-center justify-content-center" @click="
                  $store.dispatch('sms/setActiveContactByReferral', referral)
                ">
            <font-awesome-icon :icon="['far', 'comment-alt-dots']" class="mr-2" />
            Schedule via SMS
          </button> -->
            <!-- <button v-else-if="!isSchedulable && $helpers.isCompletable(referral)" @click="$router.push(`/op-report/${referral.practice.id}/${referral.id}/`)" style="padding: 0.85rem 1.75rem;" class="btn btn-lg btn-primary d-flex align-items-center justify-content-center">
            Send Op Report
          </button> -->
            <button v-if="!referral.is_incoming && !referral.sent_time" type="button" title="Preview &amp; Send Referral" class="btn btn-lg btn-primary " style="padding: 0.85rem 1.75rem;" @click="$emit('send', referral)" data-v-tour="sendReferral">
              Preview &amp; Send
            </button>

            <template v-if="referral.is_incoming && !(referral.completed_time || referral.cancelled_time )">

              <div v-if="visibleScheduleAttemptScreen == SCHEDULE_ATTEMPT_SCREENS.IS_WHY_NOT">
                <div class="d-flex justify-content-center align-items-center">
                  <!-- <div>
                  <button @click="visibleScheduleAttemptScreen = SCHEDULE_ATTEMPT_SCREENS.SNOOZE_SCREEN" class="btn btn-outline-primary mr-2">
                    Patient not reachable
                  </button>
                </div> -->
                  <!-- <div class="">
                  <button @click="patientNotInterested" class="btn btn-link  ">
                    Cannot schedule
                  </button>
                </div> -->
                  <div class="">
                    <button @click="markScheduled" class="btn btn-primary btn-lg ml-2 " style="padding: 0.85rem 1.75rem;" :disabled="isMarkingScheduled">
                      Mark scheduled
                    </button>
                  </div>
                </div>
                <!-- <div class="d-flex mt-1">
              <small>
                <a
                  href="javascript:void(0)"
                  @click="isCouldntMakeAppointment = false"
                  class="text-muted"
                  ><font-awesome-icon :icon="['far', 'angle-left']" /> back
                </a></small
              >
            </div> -->
              </div>
              <div v-if="visibleScheduleAttemptScreen == SCHEDULE_ATTEMPT_SCREENS.SNOOZE_SCREEN">
                <div class="d-flex justify-content-center align-items-center">
                  <div style="font-size:1.25rem; flex:1">
                    Move back to "Needs Action" in
                  </div>
                  <div class="ml-2">
                    <select @change="setSnoozeTime" v-model="snoozeOption" class="form-control primary-select">
                      <option v-for="opt in snoozeOptions" :value="opt[1]" :key="opt[1]">{{opt[0]}}</option>
                    </select>
                  </div>
                </div>
              </div>
              <div v-if="visibleScheduleAttemptScreen == SCHEDULE_ATTEMPT_SCREENS.SET_APPOINTMENT_TIME">
                <div class="d-flex justify-content-center align-items-center">
                  <!-- <h3 class="mb-0">Set an appointment time for helpful insights</h3> -->

                  <div v-if="referral.scheduled_time" class="">
                    <scheduled-button :referral="referral" style="font-size:1.25rem;" :allowDelete="true">
                      <a href="#" class="btn btn-link">{{referral.scheduled_time ? 'Change appointment' : 'Set appointment time'}}</a>
                    </scheduled-button>
                  </div>
                  <div class="">
                    <button @click="$helpers.completeReferral(referral)" style="padding: 0.85rem 1.75rem;" class="btn btn-primary btn-lg ml-2">
                      Complete
                    </button>
                  </div>
                  <!-- <font-awesome-icon :icon="['far', 'ellipsis-v']" size="3x" class="text-muted ml-3" /> -->
                </div>
              </div>
              <!-- <div v-if="visibleScheduleAttemptScreen == SCHEDULE_ATTEMPT_SCREENS.THANK_YOU_FOR_FEEDBACK">
              <div class="d-flex justify-content-center align-items-center">
                <h3 class="mb-0">Thanks for your feedback!</h3>
              </div>
            </div> -->
            </template>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import moment from 'moment'
import Status from '@/components/referrals/Status.vue'
import ScheduledButton from '@/components/referrals/ScheduleButton'

const SCHEDULE_ATTEMPT_SCREENS = {
  IS_WHY_NOT: 2,
  SNOOZE_SCREEN: 3,
  SET_APPOINTMENT_TIME: 4,
  THANK_YOU_FOR_FEEDBACK: 5,
}
export default {
  props: ['referralId', 'isSaving'],
  components: { Status, ScheduledButton },
  created() {
    this.SCHEDULE_ATTEMPT_SCREENS = SCHEDULE_ATTEMPT_SCREENS
  },
  data() {
    return {
      visibleScheduleAttemptScreen: SCHEDULE_ATTEMPT_SCREENS.IS_WHY_NOT,
      snoozeOption: null,
      isMarkingScheduled: false,
    }
  },
  mounted() {
    this.setActiveScreen()
  },
  watch: {
    isLoaded(isReferralsLoaded) {
      if (isReferralsLoaded) this.setActiveScreen()
    },
  },
  computed: {
    ...mapGetters('auth', ['isIntegrationActive', 'user']),
    ...mapGetters('referrals', ['all', 'get']),
    ...mapState('referrals', ['isLoaded']),
    ...mapGetters('tour', ['currentTarget']),
    referral() {
      return this.get(this.referralId)
    },
    isSchedulable() {
      return (
        this.referral &&
        this.$helpers.isSchedulable(this.referral) &&
        !this.referral.scheduled_time
      )
    },
    snoozeOptions() {
      return [
        ['1 day', moment().add(1, 'days').toISOString()],
        ['3 days', moment().add(3, 'days').toISOString()],
        ['7 days', moment().add(7, 'days').toISOString()],
        ['30 days', moment().add(1, 'month').toISOString()],
        ['90 days', moment().add(3, 'month').toISOString()],
        ['Never', null],
      ]
    },
    isTourFixAppliedToTable() {
      return this.currentTarget == '[data-v-tour="sendReferral"]'
    },
  },
  methods: {
    async patientNotInterested() {
      this.snoozeOption = this.snoozeOptions[0][1]
      this.setSnoozeTime()
      this.visibleScheduleAttemptScreen = SCHEDULE_ATTEMPT_SCREENS.SNOOZE_SCREEN
    },
    async setSnoozeTime() {
      const _this = this
      let item = { ...this.referral }

      item[`snooze_until_${!item.is_incoming ? 'from' : 'to'}_time`] =
        this.snoozeOption
      item[`archived_${!item.is_incoming ? 'from' : 'to'}_time`] = moment.utc()

      try {
        //todo: change to dispatch ref51
        await this.$store.dispatch('referrals/save', item)
        // await this.$store.commit('referrals/saveReferral', item)
      } catch (err) {
        this.$exception(err)
      }
    },
    async markScheduled() {
      this.isMarkingScheduled = true
      await this.$store.dispatch('referrals/save', {
        ...this.referral,
        is_marked_scheduled: true,
      })
      this.isMarkingScheduled = false
      this.visibleScheduleAttemptScreen =
        SCHEDULE_ATTEMPT_SCREENS.SET_APPOINTMENT_TIME
    },
    setActiveScreen() {
      this.visibleScheduleAttemptScreen = this.referral?.is_marked_scheduled
        ? SCHEDULE_ATTEMPT_SCREENS.SET_APPOINTMENT_TIME
        : SCHEDULE_ATTEMPT_SCREENS.IS_WHY_NOT
    },
  },
}
</script>

<style lang="scss" scoped>
.top-bar-container {
  // position: fixed;
  // width: calc(100% - 350px);
  z-index: 888;
  .view-header {
    background: var(--border-color);
    display: flex;
    padding: 1rem 2rem;
    min-height: 85px;
    h3 {
      line-height: 2rem;
    }
    & > div {
      // flex: 1;
      padding-right: 1rem;

      &:first-child {
        padding-left: 0;
      }
      &:last-child {
        padding-right: 0;
      }
    }
    .btn-outline-primary {
      background-color: var(--light-color);
      &:hover {
        background-color: var(--primary-color);
        color: var(--light-color);
      }
    }
  }
}

.primary-select {
  border: 0;
  border-bottom: 2px dotted var(--primary-color);
  background-color: transparent;
  font-size: 1.125rem;
  color: var(--primary-color);
  font-weight: bold;
}
@media (min-width: 576px) {
  .view-referral-wrapper {
    .view-header {
      padding: 1.5rem 2.5rem;
    }
  }
  .referral-page-wrapper {
    padding: 0 2.5rem;
  }
}
.z-index-for-tour-unset {
  z-index: unset;
}
</style>